import { mangaList } from '@/mocks/manga';
import MangaCard from '@/components/base/MangaCard';

export default function LatestUpdate() {
  const latestManga = [...mangaList].sort((a, b) =>
    new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime()
  ).slice(0, 8);

  return (
    <section className="py-10 md:py-14 bg-background-50">
      <div className="max-w-screen-2xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-6 md:mb-8">
          <div>
            <h2 className="text-xl md:text-2xl font-heading text-foreground-950">
              <i className="ri-time-line text-accent-500 mr-2"></i>
              最近更新
            </h2>
            <p className="text-sm text-foreground-500 mt-1">最新章节第一时间同步更新</p>
          </div>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-4 gap-4 md:gap-5">
          {latestManga.map((manga) => (
            <MangaCard key={manga.id} manga={manga} />
          ))}
        </div>
      </div>
    </section>
  );
}